import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { useState } from "react";

interface Option {
  value?: string;
  label: string;
}

interface AddableAutocompleteProps {
  value: string | null | undefined;
  onChange: (newValue: string) => void;
  options: Option[];
  label?: string;
  placeholder?: string;
}

const filter = createFilterOptions<Option>();

export const AddableAutocomplete = ({
  value,
  onChange,
  options,
  label = "",
  placeholder,
}: AddableAutocompleteProps) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      value={value ? { label: value } : null}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          onChange(newValue || "");
        } else if (newValue && newValue.value) {
          onChange(newValue.value || "");
        } else {
          onChange(newValue ? newValue.label : "");
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        const isExisting = options.some((option) => inputValue === option.label);
        if (inputValue !== '' && !isExisting) {
          filtered.push({
            value: inputValue,
            label: `Add "${inputValue}"`,
          });
        }
        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      options={options}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        if (option.value) {
          return option.value;
        }
        return option.label;
      }}
      renderOption={(props, option) => (
        <li {...props}>{option.label}</li>
      )}
      freeSolo
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
        />
      )}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
    />
  );
};